var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"text text-right text-small"},[_vm._v(" 上海屋聚网络科技有限公司"),_c('br'),_vm._v(" 上海屋聚公共租赁住房运营有限公司 ")])}]

export { render, staticRenderFns }